import * as React from "react";

export default class DownloadProgressModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: false,
            progress: 0,
            status: '',
            message: '',
            taskId: null,
            intervalId: null
        };
        
        // Bind methods to this instance
        this.show = this.show.bind(this);
        this.update = this.update.bind(this);
        this.dismiss = this.dismiss.bind(this);
        this.setIntervalId = this.setIntervalId.bind(this);
        
        // Make this instance globally available
        if (typeof window !== 'undefined') {
            window.DownloadProgressModal = this;
        }
    }

    show(taskId, initialMessage = 'Starting download...') {
        console.log('DownloadProgressModal.show called with:', taskId, initialMessage);
        this.setState({
            isVisible: true,
            progress: 0,
            status: 'Starting',
            message: initialMessage,
            taskId: taskId
        });
        console.log('Modal state updated, isVisible:', this.state.isVisible);
    }

    update(progress, status, message) {
        this.setState({
            progress: progress,
            status: status,
            message: message
        });
    }

    dismiss() {
        if (this.state.intervalId) {
            clearInterval(this.state.intervalId);
        }
        this.setState({
            isVisible: false,
            progress: 0,
            status: '',
            message: '',
            taskId: null,
            intervalId: null
        });
    }

    setIntervalId(intervalId) {
        this.setState({ intervalId });
    }

    render() {
        console.log('DownloadProgressModal render called, isVisible:', this.state.isVisible);
        if (!this.state.isVisible) {
            return null;
        }

        const modalOverlay = {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
            fontFamily: 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif'
        };

        const modalContent = {
            background: '#fff',
            borderRadius: 12,
            padding: '24px',
            maxWidth: 400,
            width: '90%',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
            textAlign: 'center',
            position: 'relative',
            animation: 'modalSlideIn 0.3s ease-out'
        };

        const title = {
            fontSize: 18,
            fontWeight: 700,
            color: '#395d9a',
            marginBottom: 20,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 12
        };

        const progressContainer = {
            marginBottom: 20
        };

        const progressBar = {
            width: '100%',
            height: 8,
            backgroundColor: '#e0e7ef',
            borderRadius: 4,
            overflow: 'hidden',
            marginBottom: 10
        };

        const progressFill = {
            height: '100%',
            background: 'linear-gradient(90deg, #2bbbad 0%, #395d9a 100%)',
            borderRadius: 4,
            transition: 'width 0.3s ease',
            width: `${this.state.progress}%`
        };

        const progressText = {
            fontSize: 13,
            fontWeight: 600,
            color: '#395d9a',
            marginBottom: 6
        };

        const statusText = {
            fontSize: 14,
            fontWeight: 600,
            color: '#2bbbad',
            marginBottom: 6
        };

        const messageText = {
            fontSize: 12,
            color: '#666',
            lineHeight: 1.4,
            marginBottom: 20
        };

        const cancelButton = {
            background: '#6c757d',
            color: '#fff',
            border: 'none',
            padding: '8px 16px',
            borderRadius: 6,
            fontSize: 12,
            cursor: 'pointer',
            fontWeight: 600,
            transition: 'background-color 0.2s'
        };

        const closeButton = {
            position: 'absolute',
            top: '12px',
            right: '12px',
            background: 'none',
            border: 'none',
            fontSize: '18px',
            color: '#999',
            cursor: 'pointer',
            padding: '4px',
            borderRadius: '50%',
            width: '28px',
            height: '28px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s'
        };

        const getStatusIcon = () => {
            if (this.state.status === 'Starting') return 'fa fa-play';
            if (this.state.status === 'Processing') return 'fa fa-cog fa-spin';
            if (this.state.status === 'Completed') return 'fa fa-check';
            if (this.state.status === 'Error') return 'fa fa-exclamation-triangle';
            return 'fa fa-download';
        };

        const getStatusColor = () => {
            if (this.state.status === 'Completed') return '#28a745';
            if (this.state.status === 'Error') return '#dc3545';
            return '#2bbbad';
        };

        return (
            <div style={modalOverlay} className="download-modal-overlay">
                <div style={modalContent} className="download-modal-content">
                    <button 
                        style={closeButton}
                        onClick={() => this.dismiss()}
                        onMouseOver={e => {
                            e.currentTarget.style.background = '#f0f0f0';
                            e.currentTarget.style.color = '#666';
                        }}
                        onMouseOut={e => {
                            e.currentTarget.style.background = 'none';
                            e.currentTarget.style.color = '#999';
                        }}
                        title="Close"
                    >
                        ×
                    </button>
                    
                    <div style={title}>
                        <span className="fa fa-download" style={{color: '#2bbbad'}}/>
                        Download Progress
                    </div>
                    
                    <div style={progressContainer}>
                        <div style={progressText}>
                            {this.state.progress}% Complete
                        </div>
                        <div style={progressBar}>
                            <div style={progressFill}></div>
                        </div>
                        <div style={{...statusText, color: getStatusColor()}}>
                            <span className={getStatusIcon()} style={{marginRight: 8}}/>
                            {this.state.status}
                        </div>
                    </div>
                    
                    <div style={messageText}>
                        {this.state.message}
                    </div>
                    
                    <button 
                        style={cancelButton}
                        onClick={() => this.dismiss()}
                        onMouseOver={e => e.currentTarget.style.background = '#5a6268'}
                        onMouseOut={e => e.currentTarget.style.background = '#6c757d'}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        );
    }
} 